<template>
  <div v-if="mvisible">
    <transition name="fade">
      <div class="zoom-lightbox" v-show="mviz" v-on:click="handleLbClose">
        <div class="centralizer">
          <transition name="fscale">
            <div ref="zholder" v-show="vizPanel" >
              <slot></slot>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  data () {
    return {
      vizPanel: false,
      mviz: false,
      mvisible: false
    }
  },
  model: {
    prop: 'visible',
    event: 'close'
  },
  mounted () {
    if(this.visible === true) {
      this.startOpen()
    }
  },
  methods: {
    handleLbClose: function (e) {
      if(this.$refs.zholder){
        if(this.$refs.zholder.contains(e.target)){
          return
        }
      }
      this.startClose()
    },
    startClose: async function () {
      this.vizPanel = false
      await this.$k.waitfor(100)
      this.mviz = false
      await this.$k.waitfor(200)
      this.mvisible = false
      this.$emit('close', false)
      
    },
    startOpen: async function () {
      this.mvisible = true
      this.submitted = false
      await this.$k.waitfor(100)
      this.mviz = true
      await this.$k.waitfor(100)
      this.vizPanel = true
    }
  },
  watch: {
    visible: function () {
      if(this.visible === true) {
        this.startOpen()
      }
      else {
        this.startClose()
      }
    }
  }
}
</script>

<style>

</style>
